<template>
  <div id="grouping">
    <div class="header flex-between">
      <div class="header-text">
        <h1>条件分组-查看</h1>
      </div>

      <div class="header-button">
        <el-button
          icon="iconfont icon-sousuo1"
          style="color: #a19b5a"
          @click="exportMember"
          >导出会员</el-button
        >
        <el-button
          icon="iconfont icon-fanhui"
          style="color: #a19b5a"
          @click="backBtn"
          >返回</el-button
        >
      </div>
    </div>
    <div class="tabs flex-between">
      <div class="left">
        <el-card>
          <el-form label-width="6.25rem" :model="form" size="small" disabled>
            <el-form-item label="分组名称">
              <el-input v-model="form.grpinfo.custGrpName"></el-input>
            </el-form-item>
            <el-form-item label="分组类型">
              <el-select style="width: 100%" v-model="form.grpinfo.grpKind">
                <el-option
                  v-for="item in fenZhuOptions"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分组描述">
              <el-input
                v-model="form.grpinfo.remark"
                type="textarea"
                :rows="5"
              ></el-input>
            </el-form-item>
            <el-form-item label="创建人员">
              <el-input v-model="form.grpinfo.createUserName"></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-input v-model="form.grpinfo.createTimestr"></el-input>
            </el-form-item>
            <el-form-item label="最后修改人员">
              <el-input v-model="form.grpinfo.updateUserName"></el-input>
            </el-form-item>
            <el-form-item label="最后修改时间">
              <el-input v-model="form.grpinfo.updateTimestr"></el-input>
            </el-form-item>
            <el-form-item label="启用人员">
              <el-input v-model="form.grpinfo.invalidUserName"></el-input>
            </el-form-item>
            <el-form-item label="启用时间">
              <el-input v-model="form.grpinfo.reviewTimeStr"></el-input>
            </el-form-item>
            <el-form-item label="禁用人员">
              <el-input v-model="form.grpinfo.reviewUserName"></el-input>
            </el-form-item>
            <el-form-item label="禁用时间">
              <el-input v-model="form.grpinfo.invalidTime"></el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
      <div class="right">
        <el-tabs type="border-card" @tab-click="tabarList">
          <el-tab-pane label="筛选条件">
            <div>
              <el-form size="small" label-width="5rem" disabled>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="办卡门店">
                      <el-radio v-model="form.line[0].value2" :label="1"
                        >包含</el-radio
                      >
                      <el-radio v-model="form.line[0].value2" :label="2"
                        >排除</el-radio
                      >
                      <div class="xzBox">
                        <ul style="overflow: auto">
                          <li>
                            <div style="border: #999">
                              <p v-for="(item, index) in ppt" :key="index">
                                {{ item.lable }}
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="维护门店">
                      <el-radio v-model="form.line[1].value2" :label="1"
                        >包含</el-radio
                      >
                      <el-radio v-model="form.line[1].value2" :label="2"
                        >排除</el-radio
                      >
                      <div class="xzBox">
                        <ul style="overflow: auto">
                          <li>
                            <div style="border: #999">
                              <p v-for="(item, index) in pps" :key="index">
                                {{ item.lable }}
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item>
                      <el-checkbox
                        v-model="form.line[2].condiField"
                        :true-label="3"
                        false-label="-3"
                        >会员等级</el-checkbox
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="19">
                    <el-form-item label="">
                      <el-checkbox-group v-model="levelList">
                        <!-- <el-checkbox :label="1">访者</el-checkbox>
                        <el-checkbox :label="2">学者</el-checkbox>
                        <el-checkbox :label="3">行家</el-checkbox>
                        <el-checkbox :label="4">专家</el-checkbox>
                        <el-checkbox :label="5">藏家</el-checkbox> -->
                        <el-checkbox
                          v-for="item in checkbooksData"
                          :key="item.levelID"
                          :value="item.levelID"
                          :label="item.levelID"
                        >
                          {{ item.levelName_cn }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="">
                      <el-checkbox-group v-model="form.line[3].condiField">
                        <el-checkbox :label="4" :true-label="4" false-label="-4"
                          >会员积分</el-checkbox
                        >
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="19">
                    <el-form-item>
                      <div class="flex-between">
                        <span>从</span>
                        <el-input
                          style="width: 45%"
                          v-model="form.line[3].value1"
                        ></el-input>
                        <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                        <el-input
                          style="width: 45%"
                          v-model="form.line[3].value2"
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="">
                      <!-- <el-checkbox-group v-model="form.line[4].condiField">
                        <el-checkbox :label="5" :true-label="5" false-label="-5"
                          >首次升级VIC距今天数</el-checkbox
                        >
                      </el-checkbox-group> -->
                      <el-checkbox v-model="form.line[4].condiField" :label="5"
                        >首次升级VIC距今天数</el-checkbox
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="19">
                    <el-form-item>
                      <div class="flex-between">
                        <span>从</span>
                        <el-input
                          style="width: 45%"
                          v-model="form.line[4].value1"
                        ></el-input>
                        <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                        <el-input
                          style="width: 45%"
                          :value="
                            form.line[4].value2 > 0 ? form.line[4].value2 : ''
                          "
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="">
                      <el-checkbox-group v-model="form.line[5].condiField">
                        <el-checkbox :true-label="6" false-label="-6"
                          >R(最近消费日距今天数)</el-checkbox
                        >
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="19">
                    <el-form-item>
                      <div class="flex-between">
                        <span>从</span>
                        <el-input
                          style="width: 45%"
                          v-model="form.line[5].value1"
                        ></el-input>
                        <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                        <el-input
                          style="width: 45%"
                          :value="
                            form.line[5].value2 > 0 ? form.line[5].value2 : ''
                          "
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item>
                      <el-checkbox-group v-model="form.line[6].condiField">
                        <el-checkbox :true-label="7" false-label="-7"
                          >M(距今N天内的消费总金额)</el-checkbox
                        >
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="19">
                    <el-form-item label="">
                      <div class="flex-between">
                        <span>从</span>
                        <el-input
                          style="width: 45%"
                          v-model="form.line[6].value1"
                        ></el-input>
                        <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                        <el-input
                          style="width: 45%"
                          :value="
                            form.line[6].value2 > 0 ? form.line[6].value2 : ''
                          "
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="">
                      <el-checkbox-group v-model="form.line[7].condiField">
                        <el-checkbox :true-label="8" false-label="-8"
                          >F(距今N天内的消费次数)</el-checkbox
                        >
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="19">
                    <el-form-item>
                      <div class="flex-between">
                        <span>从</span>
                        <el-input
                          style="width: 45%"
                          v-model="form.line[7].value1"
                        ></el-input>
                        <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                        <el-input
                          style="width: 45%"
                          :value="
                            form.line[7].value2 > 0 ? form.line[7].value2 : ''
                          "
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="">
                      <el-checkbox-group v-model="form.line[8].condiField">
                        <el-checkbox
                          :true-label="9"
                          false-label="-9"
                          name="type"
                          >今年消费总额</el-checkbox
                        >
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="19">
                    <el-form-item>
                      <div class="flex-between">
                        <span>从</span>
                        <el-input
                          style="width: 45%"
                          v-model="form.line[8].value1"
                        ></el-input>
                        <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                        <el-input
                          style="width: 45%"
                          :value="
                            form.line[8].value2 > 0 ? form.line[8].value2 : ''
                          "
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item>
                      <el-checkbox-group v-model="form.line[9].condiField">
                        <el-checkbox
                          :true-label="10"
                          false-label="-10"
                          name="type"
                          >今年消费次数</el-checkbox
                        >
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="19">
                    <el-form-item label="">
                      <div class="flex-between">
                        <span>从</span>
                        <el-input
                          style="width: 45%"
                          v-model="form.line[9].value1"
                        ></el-input>
                        <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                        <el-input
                          style="width: 45%"
                          :value="
                            form.line[9].value2 > 0 ? form.line[9].value2 : ''
                          "
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="">
                      <el-checkbox-group v-model="form.line[10].condiField">
                        <el-checkbox :true-label="11" false-label="-11"
                          >最近一年消费金额</el-checkbox
                        >
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="19">
                    <el-form-item>
                      <div class="flex-between">
                        <span>从</span>
                        <el-input
                          style="width: 45%"
                          v-model="form.line[10].value1"
                        ></el-input>
                        <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                        <el-input
                          style="width: 45%"
                          :value="
                            form.line[10].value2 > 0 ? form.line[10].value2 : ''
                          "
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="会员清单">
            <div>
              <el-form
                label-width="7.5rem"
                :model="config"
                :inline="true"
                size="small"
              >
                <el-form-item label="会员卡号\姓名">
                  <el-input
                    v-model="config.search"
                    style="width: 10.625rem"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="维护店">
                  <el-input v-model="config.shopCode" clearable></el-input>
                </el-form-item>
                <el-form-item label="当前维护人">
                  <el-input v-model="config.shopEmpName" clearable></el-input>
                </el-form-item>
                <el-button
                  icon="iconfont icon-sousuo1"
                  size="mini"
                  style="color: #a19b5a; background-color: #f5f5f5"
                  @click="searchBtn"
                  >查询</el-button
                >
              </el-form>
            </div>
            <!-- 中心表格 -->
            <div class="centercard">
              <el-table
                :show-summary="true"
                :summary-method="getSummaries"
                size="small"
                class="table-style"
                border
                :header-cell-style="{
                  background: '#FCFBF2',
                  'text-align': 'center',
                  color: '#6C6839',
                }"
                :cell-style="{ 'text-align': 'center' }"
                ref="multipleTable"
                tooltip-effect="dark"
                v-el-table-infinite-scroll="load"
                v-loading="loading"
                infinite-scroll-disabled="onLoading"
                @selection-change="handleSelectionChange"
                @select="handleSelectionCheck"
                :data="tableData"
              >
                <el-table-column type="selection" width="40"> </el-table-column>
                <el-table-column prop="custName" label="顾客姓名">
                </el-table-column>
                <el-table-column prop="cardNo" label="会员卡号">
                </el-table-column>
                <el-table-column prop="levelName" label="顾客等级">
                </el-table-column>
                <el-table-column prop="mobile" label="移动电话">
                </el-table-column>
                <el-table-column prop="shopName" label="维护店">
                </el-table-column>
                <el-table-column prop="shopEmp" label="当前维护人">
                </el-table-column>
                <el-table-column prop="lastSaleDate" label="最近购买日">
                  <template slot-scope="scope">
                    <div v-if="scope.row.lastSaleDate !== null">
                      {{ scope.row.lastSaleDate | dateFormat }}
                    </div>
                    <div v-else></div>
                  </template>
                </el-table-column>
                <el-table-column prop="currYearAmount" label="今年消费金额">
                </el-table-column>
                <el-table-column prop="prevYearAmount" label="去年消费金额">
                </el-table-column>
                <el-table-column
                  prop="currAvailPoint"
                  label="当前积分"
                ></el-table-column>
              </el-table>
              <el-alert
                v-if="tableData.length >= config.pagesTotal"
                title="没有更多数据了!"
                type="warning"
                center
                :closable="false"
              >
              </el-alert>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import { queryLSelectApi } from "@/api/user"; // 会员等级接口
import { lookGroundApi, queryGrpListApi } from "@/api/marketing";
export default {
  name: "GiadaConditionallook",
  data() {
    return {
      radio: "",
      loading: false,
      ruleForm: {
        radio: "",
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      fenZhuOptions: [
        {
          value: "",
          label: "所有",
        },
        {
          value: 0,
          label: "公共分组",
        },
        {
          value: 1,
          label: "个人分组",
        },
      ],
      config: {
        //查询
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        customerGrpID: "",
        search: "",
        shopCode: "",
        shopEmpName: "",
      },
      tableData: [],
      form: {
        grpinfo: {},
        line: [
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: " ",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
          {
            condiField: "",
            condiOP: "",
            value1: "",
            value2: "",
          },
        ],
        condiField: "",
        shops: [],
      },
      checkbooksData: [],
      levelList: [],
      ppt: [],
      pps: [],
      lock: false, //防止用户快速重复点击请求查询
    };
  },
  created() {
    this.lookInformation();

    this.lookLsss();
  },
  computed: {
    // isMore () {
    //   // console.log("1", this.config.pageNo, "2", this.config.pagesTotal)
    //   return this.tableData.length >= this.config.pagesTotal;
    // },
    onLoading() {
      return this.tableData.length >= this.config.pagesTotal;
    },
  },
  methods: {
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "";
          return;
        }
        if (index === 2) {
          sums[index] = this.config.pagesTotal;
          return;
        }
        // const values = data.map((item) => Number(item[column.property]));
        // if (!values.every((value) => isNaN(value))) {
        //   sums[index] = values.reduce((prev, curr) => {
        //     const value = Number(curr);
        //     if (!isNaN(value)) {
        //       return prev + curr;
        //     } else {
        //       return prev;
        //     }
        //   }, 0);
        //   if (index === 9||index === 8) {
        //     sums[index] += "元";
        //   }
        //   if(index===6){
        //     sums[index]=''
        //   }
        // } else {
        //   sums[index] = "";
        // }
      });

      return sums;
    },
    tabarList(tab) {
      this.tableData = [];
      if (tab.label == "会员清单") {
        this.loading = true;
        this.tableList();
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    backBtn() {
      this.$router.go(-1);
    },
    lookLsss() {
      queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
        this.checkbooksData = res.data;
      });
    },
    lookInformation() {
      lookGroundApi({
        customerGrpID: localStorage.getItem("lookId"),
      }).then((res) => {
        if (res.success) {
          this.form = res.data;
          let list = [];
          let str = {
            condiField: "",
            condiOP: "",
            customerGrpID: "",
            id: "",
            value1: "",
            value2: "",
          };
          for (let i = 0; i < 11; i++) {
            list.push(str);
          }
          list.forEach((item, index) => {
            var listIndex = index;
            res.data.line.forEach((item) => {
              if (item.condiField - 1 == listIndex) {
                list[listIndex] = item;
              }
            });
          });
          res.data.line = list;

          this.condiField = res.data.line.map((item) => {
            return item.condiField;
          });

          this.lookCheckboxList = res.data.line[2].value1.split("").map(Number);
          res.data.grpinfo.createTimestr = this.renderTime(
            res.data.grpinfo.createTime
          );
          //最后修改时间
          res.data.grpinfo.updateTimestr = this.renderTime(
            res.data.grpinfo.updateTime
          );
          // 启用时间
          res.data.grpinfo.reviewTimeStr = this.renderTime(
            res.data.grpinfo.reviewTime
          );
          //禁用时间
          res.data.grpinfo.invalidTime = this.renderTime(
            res.data.grpinfo.invalidTime
          );

          let custGrpLineShopVO = [];
          let custGrpLineShopVO1 = [];

          res.data.shops.forEach((item) => {
            if (item.condiField === 1) {
              custGrpLineShopVO.push(item.custGrpLineShopVO);
            }
            if (item.condiField === 2) {
              custGrpLineShopVO1.push(item.custGrpLineShopVO);
            }
          });

          if (custGrpLineShopVO.length > 0) {
            for (let i = 0; i < custGrpLineShopVO[0].length; i++) {
              let keyMap = {
                lable: custGrpLineShopVO[0][i].shopName,
                id: custGrpLineShopVO[0][i].shopID,
              };
              this.ppt.push(keyMap);
            }
          }

          if (custGrpLineShopVO1.length > 0) {
            for (let i = 0; i < custGrpLineShopVO1[0].length; i++) {
              let keyMap = {
                lable: custGrpLineShopVO1[0][i].shopName,
                id: custGrpLineShopVO1[0][i].shopID,
              };
              this.pps.push(keyMap);
            }
          }
          this.form.line[0].value2 = Number(this.form.line[0].value2);
          this.form.line[1].value2 = Number(this.form.line[1].value2);
          this.levelList = res.data.line[2].value1.split(";").map(Number);
        }
      });
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.SelectChang = e[e.length - 1];
      } else {
        this.SelectChang = {};
      }
    },
    handleSelectionCheck(selection, row) {
      this.$refs.multipleTable.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChang = row;
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
    },
    // 查询
    searchBtn() {
      if (this.lock) {
        return;
      }
      this.lock = true;
      this.tableData = [];
      this.config.total = 0;
      this.config.pageNo = 1;
      this.tableList();
    },
    // table表格数据
    tableList() {
      let queryInfo = {
        customerGrpID: localStorage.getItem("lookId"),
        search: this.config.search,
        shopCode: this.config.shopCode,
        shopEmpName: this.config.shopEmpName,
        pageNo: this.config.pageNo,
        pageSize: this.config.pageSize,
      };
      queryGrpListApi(queryInfo).then((res) => {
        if (res.success) {
          this.tableData = this.tableData.concat(res.data.list);
          this.config.pageSize = res.data.pageSize;
          this.config.pagesTotal = res.data.total;
          setTimeout(() => {
            this.loading = false;
            this.lock = false;
          }, 500);
        }
      });
    },
    load() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      setTimeout(() => {
        this.config.pageNo += 1;
        this.tableList();
      }, 500);
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    // 导出会员
    exportMember() {
      // exportConditionApi().then()
      const e = document.createElement("a");
      e.style.display = "node";
      // e.href =
      //   `https://gftest.redstone.com.cn/api/cust/grplist/exportCustByCondi?` +
      //   `customerGrpID=${localStorage.getItem("lookId")}`;
      e.href =
        `${process.env.VUE_APP_BASE_API}/api/cust/grplist/exportCustByCondi?` +
        `customerGrpID=${localStorage.getItem("lookId")}`;
      e.download = "";
      document.querySelectorAll("body")[0].appendChild(e);
      e.click();
      e.remove();
    },
  },
};
</script>

<style lang="scss" scoped>
#grouping {
  height: 62.5rem;
}
.card-pagination {
  margin-top: 1.25rem;
  text-align: right;
}
.header-text {
  margin: 1.25rem 0 1.25rem 0;
  color: #76734f;
}

.left {
  width: 25%;
  height: 62.5rem;
}
.right {
  width: 75%;
  margin-left: 0.625rem;
  height: 62.5rem;
}

/deep/input {
  border-radius: 0 !important;
}
::v-deep {
  .el-tabs__item.is-active {
    color: #a19b5a !important;
  }
  .el-tabs__item:hover {
    color: #a19b5a !important;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-table .success-row {
    background: #ffffff;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
  .xzBox {
    height: 6.25rem;
    width: 100%;
    border: 0.0625rem solid #ccc;
    overflow-y: auto;
  }
}
</style>